<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-lg-12 col-lg-3 vcenter">
      <h3>{{headerText}}</h3>

    </div>
    <div class="col-xs-12 col-lg-9 vcenter-right">
      <button type="button"
              class="btn btn-primary"
              [disabled]="!drawingForm.valid"
              (click)="saveDrawing()">
        <i class="fa fa-save"></i>&nbsp;Save
      </button>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />

  <form #drawingForm="ngForm">

        <mat-tab-group>
          <mat-tab label="Drawing">
            <ng-template matTabContent>

          <div style="width:99%">
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Status:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field>
                      <mat-select name="Drawing Status"
                          [(ngModel)]="drawing.drawingStatus"
                          [disabled]="!editable"
                          required>
                        <mat-option *ngFor="let s of statusValues | async" [value]="s.drawingStatusId">
                          {{ s.drawingStatusName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Reviewed By:</b>
                  </div>
                  <div class="col-xs-8">
                   <mat-form-field>
                      <mat-select name="Reviewed By"
                          [(ngModel)]="drawing.reviewedBy"
                          [disabled]="!editable"
                      >
                        <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId">
                          {{ e.fullName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Assigned Drafter:</b>
                  </div>
                  <div class="col-xs-8">
                   <mat-form-field>
                      <mat-select name="Assigned Drafter"
                          [(ngModel)]="drawing.assignedDrafter"
                          [disabled]="!editable"
                      >
                        <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId">
                          {{ e.fullName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 top10">
                <div class="row vcenter">
                  <div class="col-xs-1 text-right">
                    <b>Drawing Title:</b>
                  </div>
                  <div class="col-xs-11">
                    <mat-form-field appearance="fill" class="form-component" class="editable-text-field" style="width:100%" >
                      <input matInput type="text" style="width:100%" name="Drawing Title" [(ngModel)]="drawing.drawingTitle" [disabled]="!editable" required maxlength="255" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Site:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field>
                      <mat-select name="Site"
                          [(ngModel)]="drawing.siteId"
                          [disabled]="!editable"
                          required
                      >
                        <mat-option *ngFor="let s of sitesValues" [value]="s.siteId">
                          {{ s.siteName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Drawing Number:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field appearance="fill" >
                      <input matInput type="text" style="width:100%" name="Drawing Number" [(ngModel)]="drawing.drawingNum" [disabled]="!editable" required maxlength="255" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Ref Number:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field appearance="fill">
                    <input matInput type="text" style="width:100%" name="Ref Number" [(ngModel)]="drawing.referenceNum" [disabled]="!editable" maxlength="50" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Orig. Drawing Num:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field appearance="fill">
                      <input matInput type="text" style="width:100%" name="Original Drawing Number" [(ngModel)]="drawing.originalDrawingNum" [disabled]="!editable" maxlength="255" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Original Page:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field appearance="fill">
                      <input matInput type="text" style="width:100%" name="Original Page" [(ngModel)]="drawing.originalPageNum" [disabled]="!editable" maxlength="255" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Sheet Number:</b>
                  </div>
                  <div class="col-xs-8">
                    <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.NUMBER"
                      name="Sheet Number"
                      [(ngModel)]="drawing.pageNum"
                      [disabled]="!editable"
                      [min]="0" [maxDecimals]="0"
                      required ></aims-numeric>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Discipline:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field>
                      <mat-select name="Discipline"
                          [(ngModel)]="drawing.disciplineId"
                          [disabled]="!editable"
                          required
                      >
                        <mat-option *ngFor="let d of disciplineValues | async" [value]="d.disciplineId">
                          {{ d.discipline }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Drawing Source:</b>
                  </div>
                  <div class="col-xs-8">
                   <mat-form-field>
                      <mat-select name="Drawing Source"
                          [(ngModel)]="drawing.drawingSource"
                          [disabled]="!editable"
                      >
                        <mat-option *ngFor="let s of sourceValues | async" [value]="s.drawingSourceId">
                          {{ s.drawingSourceName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Drawing Type:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field>
                      <mat-select name="Drawing Type"
                          [(ngModel)]="drawing.drawingTypeId"
                          [disabled]="!editable"
                          required
                      >
                        <mat-option *ngFor="let t of typeValues | async" [value]="t.drawingTypeId">
                          {{ t.drawingType }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Building Number:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field appearance="fill">
                      <input matInput type="text" style="width:100%" name="Building Number" [(ngModel)]="drawing.buildingNumber" [disabled]="!editable" maxlength="50" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6 col-lg-3 top10">
                <div class="row vcenter">
                  <div class="col-xs-4 text-right">
                    <b>Drawing Format:</b>
                  </div>
                  <div class="col-xs-8">
                    <mat-form-field>
                      <mat-select name="Drawing Format"
                          [(ngModel)]="drawing.drawingFormat"
                          [disabled]="!editable"
                          required
                      >
                        <mat-option *ngFor="let f of formatValues | async" [value]="f.drawingFormatId">
                          {{ f.drawingFormatName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 top10">
                <div class="row vcenter">
                  <div class="col-xs-1 text-right">
                    <b>Comments:</b>
                  </div>
                  <div class="col-xs-11">
                    <mat-form-field appearance="fill" class="form-component" class="editable-text-field" style="width:100%">
                      <textarea matInput style="width:100%" name="Comments" [(ngModel)]="drawing.comments" [disabled]="!editable" rows="5" maxlength="255"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>

      </ng-template>
      </mat-tab>

      <mat-tab label="Drawing History">
        <ng-template matTabContent>

          <aims-common-table
            *ngIf="drawing.engCadDrawingHistory.length > 0"
            id="drawing-history-table"
            [dataSource]="drawing.engCadDrawingHistory"
            [header]="tableHeader"
            [permissions]="tablePermissions"
            [pageSize]="20"
            [stickyHeader]="true">

            <aims-common-table-dynamic-row id="changedBy">
              <ng-template viewMode let-element >
                {{ element.changedById | getText:'employeeId':'fullName':employeeValues  }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="drawingStatus">
              <ng-template viewMode let-element >
                {{ element.drawingStatus | getText:'drawingStatusId':'drawingStatusName':statusValues | async }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="assignedDrafter">
              <ng-template viewMode let-element >
                {{ element.assignedDrafter | getText:'employeeNumber':'fullName':employeeValues }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="siteId">
              <ng-template viewMode let-element >
                {{ element.siteId | getText:'siteId':'siteName':sitesValues }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="disciplineId">
              <ng-template viewMode let-element >
                {{ element.disciplineId | getText:'disciplineId':'discipline':disciplineValues | async }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="drawingSource">
              <ng-template viewMode let-element >
                {{ element.drawingSource | getText:'drawingSourceId':'drawingSourceName':sourceValues | async }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="drawingTypeId">
              <ng-template viewMode let-element >
                {{ element.drawingTypeId | getText:'drawingTypeId':'drawingType':typeValues | async }}
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>

        </ng-template>
      </mat-tab>
    </mat-tab-group>

  </form>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
